// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_ca2","cls2":"ActionNav-cls2_7P1 ActionNav-cls1_ca2"};